/**
 * @const
 * @type {Object<string, string>}
 */
export const StoryAdSegmentExp = {
  ID: 'story-ad-auto-advance',
  CONTROL: '31067116', // No change
  AUTO_ADVANCE_OLD_CTA: '31067117', // Auto advance, old CTA button
  AUTO_ADVANCE_NEW_CTA: '31067118', // Auto advance, new CTA button
  AUTO_ADVANCE_NEW_CTA_NOT_ANIMATED: '31067119', // Auto advance, new CTA button but not animated
};
